import React from "react";
import tw from "tailwind-styled-components";
import Model from "../Model";
import moment from "moment";
import {
  SubmitBtn,
  OtherBtn,
  CancelBtn
} from "../Styles/InputStyles";

const OtherServicesFeeModal = ({ setOpenOtherServicesFeeModal, selectedItem, serviceType }) => {
  return (
    <Model width={"w-8/12 max-w-2xl"} setOpenModel={setOpenOtherServicesFeeModal}>
      <Wrapper>
        <Title>Annual Fee Details</Title>

        <SingleItem name={"Registry Perusal fee"} value={"TZS 50,000"} />
        <SingleItem name={"Certificate Notarization Fee"} value={"TZS 50,000"} />
        <SingleItem name={"Duplicate Certificate Fee"} value={"TZS 50,000"} />
        <SingleItem name={"Constitutional Amendment Fee"} value={"TZS 50,000"} />
        <SingleItem name={"Fee for Change of Club / Sport Association Leadership"} value={"TZS 50,000"} />
        <SingleItem name={"Fee for Change of Club / Sport Association Ownership"} value={"2% ya mapato ghafi la mauziano"} />
        <SingleItem name={"Other Application"} value={"TZS 50,000"} />  

        
      </Wrapper>
      <BtnWrapper>
          <CancelBtn onClick={() => setOpenOtherServicesFeeModal(false)}>Close</CancelBtn>
      </BtnWrapper>
    </Model>
  );
};

const SingleItem = ({ name, value, link, url }) => (
  <div className="flex items-center py-2 border-b border-gray-100 ">
    <Name>{name}</Name> <p className="w-10">:</p>
    {link && (
      <LinkValue href={url} target="_blank" title="Click to open">
        {value}
      </LinkValue>
    )}
    {!link && <Value>{value}</Value>}
  </div>
);

const Wrapper = tw.div`px-4`;
const Title = tw.h2`text-lg md:text-xl mb-6 text-gray-700 font-medium text-left`;
const Name = tw.p`text-sm text-gray-500  w-60`;
const Value = tw.p`text-sm text-gray-800 font-medium max-w-xs `;
const LinkValue = tw.a`text-sm text-blue-500 max-w-xs truncate cursor-pointer`;
const BtnWrapper = tw.div` w-full flex items-center justify-end space-x-10 mt-8`;

export default OtherServicesFeeModal;
